import styles from "./brands.module.css";

export default function BrandSlider() {
  const logos = [
    "/baidyanath.png",
    "/himalaya.png",
    "/dabaur.png",
    "/horlicks.png",
    "/lakme.png",
    "/pathanjali.png"
  ];

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Brands</h2>

      <div className={styles.slider}>
        <div className={styles.track}>
          
          {/* First set */}
          {logos.map((logo, index) => (
            <div className={styles.slide} key={index}>
              <img src={logo} alt="brand" />
            </div>
          ))}

          {/* Duplicate for infinite scroll */}
          {logos.map((logo, index) => (
            <div className={styles.slide} key={`dup-${index}`}>
              <img src={logo} alt="brand" />
            </div>
          ))}

        </div>
      </div>
    </div>
  );
}